import { AlkLogger } from '@alk/core';
import {
    IForwardOrderRequest,
    IPendingOrderRequest,
    IPlaceOrderResponse,
    ISpotOrderRequest,
} from '../../interfaces';
import { injectable } from 'inversify';
import { IPlaceOrder } from './place-order.interface';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class PlaceOrderMock implements IPlaceOrder {
    orderRequestObservable(): Observable<void> {
        AlkLogger.debug('PlaceOrderMock#orderRequestObservable');
        return NEVER;
    }

    sendPendingOrderRequest(request: IPendingOrderRequest): Promise<IPlaceOrderResponse> {
        AlkLogger.debug('PlaceOrderMock#sendPendingOrderRequest', request);

        return Promise.resolve({
            isAccepted: true,
        });
    }

    sendForwardOrderRequest(request: IForwardOrderRequest): Promise<IPlaceOrderResponse> {
        AlkLogger.debug('PlaceOrderMock#sendForwardOrderRequest', request);

        return Promise.resolve({
            isAccepted: true,
        });
    }

    sendSpotOrderRequest(request: ISpotOrderRequest): Promise<IPlaceOrderResponse> {
        AlkLogger.debug('PlaceOrderMock#sendSpotOrderRequest', request);

        return Promise.resolve({
            isAccepted: true,
        });
    }
}
